import styled from 'styled-components';

import { Input as AntdInput } from 'antd';

import { inputStylesOverride } from './BaseInput';

const Search = styled(AntdInput.Search)`
    ${inputStylesOverride};
`;

export default Search;
